import PerformanceImage from '../../assets/website/performance.svg';
import MonitoringImage from '../../assets/website/monitor.svg';
import DomainImage from '../../assets/website/liveupdates.svg';
import LockImage from '../../assets/website/lock.svg';
import PingsImage from '../../assets/website/pings.svg';
import ChartIcon from '../../assets/icons/performance.svg';
import ServiceIcon from '../../assets/icons/service.png';
import DomainIcon from '../../assets/icons/world.svg';
import LockIcon from '../../assets/icons/lock.svg';
import PingsIcon from '../../assets/icons/pings.svg';
import { Col, Row } from 'antd';
import './Cards.css';

function Cards() {
  const card = [
    {
      icon: ChartIcon,
      header: 'Comprehensive Performance Insights',
      description: `Get detailed uptime metrics, response time analytics, and historical performance data to optimize your services and meet your SLA commitments.`,
      image: PerformanceImage,
    },
    {
      icon: ServiceIcon,
      header: 'Proactive Real-time Monitoring',
      description: `Detect issues before your customers do with minute-by-minute checks, instant alerts, and automated incident response workflows.`,
      image: MonitoringImage,
    },
    {
      icon: DomainIcon,
      header: 'Branded Status Pages',
      description: `Build trust with professional status pages on your own domain. Provide customers with transparent, real-time service status information that reinforces your commitment to reliability.`,
      image: DomainImage,
    },
    {
      icon: PingsIcon,
      header: 'Global Service Dependency Monitoring',
      description: `Monitor third-party dependent sevices which are critical to your business.`,
      image: PingsImage,
    },
    {
      icon: LockIcon,
      header: 'Secure VPC & Private Network Monitoring',
      description: `Monitor systems behind firewalls and in private networks with our secure agent technology, ensuring complete visibility across your entire infrastructure.`,
      image: LockImage,
    },
  ];

  return (
    <div className="about-cards">
      <h1 className="about-cards-header">
        Enterprise-grade monitoring <br /> for businesses of all sizes
      </h1>

      <Row gutter={[24, 24]}>
        {card.map((x, key) => (
          <Col className="gutter-row" xs={24} lg={key === Math.floor(card.length / 2) ? 24 : 12} key={key}>
            <div
              className={`card ${key < 2 && 'start-cards'} ${key === Math.floor(card.length / 2) && 'middle-card'} ${
                key > 2 && 'end-cards'
              } ${key === 1 && 'second-card'}`}
            >
              <div className="content">
                <div className="icon">
                  <img src={x.icon} alt=" " />
                </div>
                <h3 className="content-header">{x.header}</h3>
                <p className="text">{x.description}</p>
              </div>
              <div className="image">
                <img src={x.image} alt=" " />
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default Cards;
